(function() {
  'use strict';
  angular.module('app')
    .controller('SidebarCtrl', ['$rootScope', '$scope',
      function($rootScope, $scope) {

        $scope.toggled = false;
        $scope.templateUrl = '';

        $scope.$on('sidebar:toggle', function(event, content) {
          // console.log('sidebar:toggle');
          // console.log(content);
          $scope.templateUrl = content.templateUrl;
          $scope.toggle(content.added);
        });

        $scope.toggle = function() { // added
          $scope.toggled = !$scope.toggled;
        };

        $scope.$on('sidebar:close', function() {
          $scope.close();
        });

        $scope.close = function() {
          $scope.toggled = false;
          $rootScope.sidebar = false;
          $scope.templateUrl = '';
        };
      }
    ]);
}());
